import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {
    cssOverrides: {
        scrim: css`
            touch-action: auto !important;
        `,
        modalContainer: css`
            width: auto;
        `,
        modalBody: css`
            width: auto;
            max-width: initial;
            max-height: initial !important;
        `,
        modalTitle: css`
            border-bottom: none;
            padding: 10px 10px 0;
        `,
        modalContent: css`
            text-align: center;
        `,
    },
};
